// src/pages/ChangePassword.js
import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { APP_API_URL } from "../constants/appURLConstrants";
import { isStrongPassword, passwordPolicyMessage } from "../utils/passwordPolicy";

export default function ChangePassword() {
    const navigate = useNavigate();

    const [password, setPassword] = useState("");
    const [confirm, setConfirm] = useState("");
    const [error, setError] = useState("");
    //const isValid = isStrongPassword(password);

    //Check live hint for password complexity
    const passwordError =
        password && !isStrongPassword(password)
            ? passwordPolicyMessage()
            : "";


    const location = useLocation();
    const message = location.state?.message;



    const handleSubmit = async (e) => {
        e.preventDefault();

        // 1. check match first (better UX)
        if (password !== confirm) {
            setError("Passwords do not match");
            return;
        }

        // 2. password strength check
        if (!isStrongPassword(password)) {
            setError(passwordPolicyMessage());
            return;
        }



        try {
            const token = sessionStorage.getItem("token");

            const res = await fetch(`${APP_API_URL}/api/users/change-password`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({ password })
            });

            const data = await res.json();

            if (!data.success) {
                setError(data.message);
                return;
            }

            //   alert("Password updated successfully");

            //   // ✅ redirect to dashboard
            //   navigate("/dashboard");
            //alert("Password updated successfully. Please login again.");

            // ✅ clear session
            //sessionStorage.removeItem("token");
            //sessionStorage.removeItem("user");

            // ✅ redirect to login
            //navigate("/");
            //console.log("CHANGE PASSWORD RESPONSE:", data);
            // force navigation AFTER render cycle
            //setTimeout(() => {
            //    navigate("/", { replace: true });
            //}, 100);

            if (data.success) {
                //console.log("➡️ BEFORE LOGOUT NAVIGATE");

                alert("Password updated successfully. Please login again.");

                // IMPORTANT: clear everything first
                sessionStorage.clear();

                // force full app reload (resets all auth state)
                //console.log("➡️ ABOUT TO NAVIGATE");
                window.location.href = "/";

            }




        } catch (err) {
            setError("Server error");
        }
    };

    return (

        <div className="login-container" style={{ justifyContent: "center", alignItems: "center" }}>
            <div className="login-card">
                <h2>Change Password</h2>

                {error && <div className="error">{error}</div>}

                {message && (
                    <div className="user-login-warning">
                        {message}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <input
                        type="password"
                        placeholder="New Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />

                    {/* Password complexity hint */}
                    {passwordError && (
                        <div className="error">{passwordError}</div>
                    )}

                    <input
                        type="password"
                        placeholder="Confirm Password"
                        value={confirm}
                        onChange={(e) => setConfirm(e.target.value)}
                        required
                    />

                    <button type="submit">Update Password</button>
                </form>
            </div>
        </div>

    );
}